
export const KeyPressEvents = Object.freeze({
  KEY_UP: 0,
  KEY_DOWN: 1,
  RESET_PRESSED_KEYS: 2
})

// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code
const KeyCodeShims = Object.freeze({
  'OSLeft': 'MetaLeft',
  'OSRight': 'MetaRight',
  'VolumeDown': 'AudioVolumeDown',
  'VolumeUp': 'AudioVolumeUp',
  'VolumeMute': 'AudioVolumeMute',
  'Lang1': 'HangulMode',
  'Lang2': 'Hanja',
  'BrowserStop': 'Cancel',
})

// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
const KeyShims = Object.freeze({
  'OS': 'Meta',
  'VolumeDown': 'AudioVolumeDown',
  'VolumeUp': 'AudioVolumeUp',
  'VolumeMute': 'AudioVolumeMute',
  'Up': 'ArrowUp',
  'Left': 'ArrowLeft',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Crsel': 'CrSel',
  'Exsel': 'ExSel',
  'Spacebar': 'Space Bar',
  'Esc': 'Escape',
  'Apps': 'ContextMenu',
  'Zoom': 'ZoomToggle',
  'SelectMedia': 'LaunchMediaPlayer',
  'MediaSelect': 'LaunchMediaPlayer',
  'LaunchMyComputer': 'LaunchApplication1',
  'LaunchCalculator': 'LaunchApplication2',
})


/**
 * @this DataView
 */
function setUint8Array (byteOffset, value) {
  const codeBytes = new Uint8Array(this.buffer, byteOffset, value.length)
  codeBytes.set(value)
}

/**
 * @param {*} keyMessage - KeyMessage
 */
function serializeKeyMessage ({ action, code, key, location = 0, which = 0, modifierState = 0 }) {

  code = KeyCodeShims[code] ? KeyCodeShims[code] : code
  key = KeyShims[key] ? KeyShims[key] : key

  const codeToByte = new TextEncoder('utf-8').encode(code)
  const codeLength = codeToByte.length
  const keyToByte = new TextEncoder('utf-8').encode(key)
  const keyLength = keyToByte.length

  const messageFields = [
    { length: 2, name: 'action' },
    { length: 2, name: 'location' },
    { length: 2, name: 'which' },
    { length: 2, name: 'codeLength' },
    { length: codeLength, name: 'codeBytes' },
    { length: 2, name: 'keyLength' },
    { length: keyLength, name: 'keyBytes' },
    { length: 2, name: 'modifierState' },
  ]

  const messageLength = messageFields.reduce((acc, f) => acc + f.length, 0)
  const buf = new ArrayBuffer(messageLength)

  const messageStruct = new DataView(buf, 0, messageLength)

  // @TODO whats with this
  DataView.prototype.setUint8Array = setUint8Array // eslint-disable-line

  messageStruct.setUint16(0, action, true)
  messageStruct.setUint16(2, location, true)
  messageStruct.setUint16(4, which, true)
  messageStruct.setUint16(6, codeLength, true)
  messageStruct.setUint8Array(8, codeToByte)
  messageStruct.setUint16(8 + codeLength, keyLength, true)
  messageStruct.setUint8Array(10 + codeLength, keyToByte)
  messageStruct.setUint16(10 + codeLength + keyLength, modifierState, true)

  return buf
}

function serializeKeyReset ({ action }) {
  const length = 2
  const buf = new ArrayBuffer(length)
  const message = new DataView(buf, 0, length)
  message.setUint16(0, action, true)

  return buf
}

export function serialize (keyMessage) {
  const result = keyMessage.action === KeyPressEvents.RESET_PRESSED_KEYS
    ? serializeKeyReset(keyMessage)
    : serializeKeyMessage(keyMessage)

  return result
}

export const ForUnitTest = {
  serializeKeyMessage,
}

